import React from 'react';
import styled from 'styled-components';
import useSelectorUser from '@/hooks/use-selector-user';
import media from '@/styles/media';
import theme from '@/styles/theme';
import { Wrapper, LayoutWrapper } from '../new-auth-layout';
import { Logo } from './logo';

export const AuthLayout: React.FC = ({ children }) => {
  const { currentPage } = useSelectorUser('authModal');

  return (
    <Wrapper>
      <Background>
        <LeftDiv>
          <TextContainer>
            <Logo />
            <LeftLargeText>
              Digital
              <br />
              Dynamic
              <br />
              Interactive
            </LeftLargeText>
            <LeftSubText>
              STEAM Education
              <br />
              Contents Platform
            </LeftSubText>
          </TextContainer>
          <ImageContainer>
            <RocketImg src="/assets/images/auth/rocket.png" alt="rocket image" />
            <CloudImg src="/assets/images/auth/cloud.png" alt="cloud image" />
          </ImageContainer>
        </LeftDiv>
      </Background>
      <LayoutWrapper>
        <ContentDiv data-current-page={currentPage}>
          {children}
        </ContentDiv>
      </LayoutWrapper>
    </Wrapper>
  );
};

const Background = styled.div`
  width: 100%;
  max-width: 760px;
  height: 100%;
  display: flex;
  justify-content:flex-end ;
  align-items: center;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url('/assets/images/auth/login-left-bg.png');
  ${media.lg`
    display: none;
  `}
  `;

const LeftDiv = styled.div`
  width: 100%;
  max-width: 500px;
  height: 100%;
  max-height: 820px;
  background-color: #FAF7FD;
  border-radius: 50px 0px 0px 50px;
  margin-left: 60px;
`;

const ContentDiv = styled.div`
  width: 100%;
  max-width: 860px;
  height: 100%;
  max-height: 819px;
  border-radius: 0px 50px 50px 0px ;
  box-sizing: border-box;
  background-color: white;
  margin-right: 60px;
  ${media.lg`
    background-color: #f8f9ff;
    margin-right: 0;
    max-width: 100%;
    max-height: 100%;
    
    border-radius: unset;
    overflow-y: auto;
    overflow-x: hidden;
  `}

`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 12rem;  
  padding: 53px 80px;
`;

const LeftLargeText = styled.div`
  margin-top:5rem; 
  font-family: ${theme.fontFamily.extraBold};
  font-style: normal;
  font-size: 38px;
  line-height: 42px;
`;

const LeftSubText = styled.div`
  margin-top: 1.5rem;   
  font-family:  ${theme.fontFamily.regular};
  font-style: normal;
  font-size: 18px;
  line-height: 24px;
`;

const ImageContainer = styled.div`
  position: relative;
  flex:1;
  ${media.lg`
    display: none;
  `}
`;

const RocketImg = styled.img`
  position: absolute;
  width: 165px;
  top: 30px;
  left: 269px;
  transform: rotate(15deg);
  ${media.xl`
    transform: scale( 0.85) rotate(15deg);
    transition: all 0.2s linear;
  `}
`;

const CloudImg = styled.img`
  position: absolute;
  width: 498px;
  left: 10px;
  top: 100px;
  ${media.xl`
    transform: scale( 0.85 );
    transition: all 0.2s linear;
  `}
`;
